var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-5 container"},[(_vm.error)?_c('div',{staticClass:"text-center"},[_c('h3',[_vm._v("Oops")]),_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error.message))]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.reload}},[_vm._v("Reload")])],1):_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }